import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  app: {
    productCode: '', // 产品Code
    innerCode: '', // 代理人Code
    h5: false // 是否是渠道
  },
  config: {
    rawBanksFromServer: [],
    banksFromServer: [],
  }, // 配置信息
  measure: {
    success: '', // 保费测试是否成功
    basePremium: 0, // 基础保费
    baseBackMoney: 0 // 每年返还
  },
  order: { // 订单信息
    unionCode: '',
    confirmFeedback: true,
    feeSuccess: false, // 保单测试保费是否成功
    offlineCode: ''
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js